<!-- <form #paypalform ngNoForm method="post" action="https://pilot-payflowlink.paypal.com"> -->
<form #paypalform ngNoForm method="post" action="https://payflowlink.paypal.com">
     <input type="hidden" name="SECURETOKEN" #securityToken>
     <input type="hidden" name="SECURETOKENID" #securityId>
     <input type="hidden" name="MODE" value="LIVE">
     <!-- <input type="hidden" name="MODE" value="TEST"> -->
     <input type="submit" value="Submit" style="visibility: hidden;">
</form>
<div class="clearfix"></div>
<form [formGroup]="confirmationform" (ngSubmit)="onlineconfirmation()">

     <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12">
          <h1 class="h2" style="color: #000; font-weight: 600">
            Apply Online Confirmation
          </h1>
          <p>
            Confirm Your Information Below :
          </p>
          <section class="find-property-css">
            <div class="container">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>First Name :</label>
                    <input type="text" class="form-control" formControlName="name"/>
                    <ngb-alert [dismissible]="false" [type]="'danger'"
                    *ngIf="confirmationform.get('name')?.dirty && confirmationform.get('name')?.invalid" class="text-left">
                    <div *ngIf="confirmationform.get('name')?.errors?.required">Name is required.</div>
                  </ngb-alert>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>Last Name :</label>
                    <input type="text" class="form-control" formControlName="Lname"/>
                    <ngb-alert [dismissible]="false" [type]="'danger'"
                            *ngIf="confirmationform.get('Lname')?.dirty && confirmationform.get('Lname')?.invalid" class="text-left">
                            <div *ngIf="confirmationform.get('Lname')?.errors?.required"> Last Name is required.</div>
                          </ngb-alert>

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>Address for Credit Card :</label>
                    <input type="text" class="form-control" formControlName="Address" />
                    <ngb-alert [dismissible]="false" [type]="'danger'"
                    *ngIf="confirmationform.get('Address')?.dirty && confirmationform.get('Address')?.invalid" class="text-left">
                    <div *ngIf="confirmationform.get('Address')?.errors?.required">Address to credit card is required.</div>
                </ngb-alert>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <label>Email </label>
                    <input type="email" class="form-control" formControlName="email"/>
                    <ngb-alert [dismissible]="false" [type]="'danger'"
                    *ngIf="confirmationform.get('email')?.dirty && confirmationform.get('email')?.invalid" class="text-left">
                            <div *ngIf="confirmationform.get('email')?.errors?.pattern">Email is invalid.</div>
                            <div *ngIf="confirmationform.get('email')?.errors?.required">Email is required.</div>
                          </ngb-alert>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                  <div class="form-group" >
                    <label>phone</label>
                    <input type="text" class="form-control" formControlName="phone" mask="000000000*" maxlength="13" [showMaskTyped]="false" />
                     <ngb-alert [dismissible]="false" [type]="'danger'"
                    *ngIf="confirmationform.get('phone')?.dirty && confirmationform.get('phone')?.invalid" class="text-left">
                    <div *ngIf="confirmationform.get('phone')?.errors?.required">phone  is required.</div>
                    <div *ngIf="confirmationform.get('phone')?.errors?.mask">phone number is invalid.</div>
                </ngb-alert>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                  <div class="form-group">
                    <label>City</label>
                    <input type="text" class="form-control " formControlName="city"/>
                    <ngb-alert [dismissible]="false" [type]="'danger'"
                            *ngIf="confirmationform.get('city')?.dirty && confirmationform.get('city')?.invalid" class="text-left">
                            <div *ngIf="confirmationform.get('city')?.errors?.required">city is required.</div>
                          </ngb-alert>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                  <div class="form-group">
                    <label>State</label>
                    <input type="text" class="form-control " formControlName="state"/>
                    <ngb-alert [dismissible]="false" [type]="'danger'"
                            *ngIf="confirmationform.get('state')?.dirty && confirmationform.get('state')?.invalid" class="text-left">
                            <div *ngIf="confirmationform.get('state')?.errors?.required">state is required.</div>
                          </ngb-alert>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                  <div class="form-group">
                    <label>zip</label>
                    <input type="text" class="form-control " formControlName="zip"/>
                    <ngb-alert [dismissible]="false" [type]="'danger'"
                            *ngIf="confirmationform.get('zip')?.dirty && confirmationform.get('zip')?.invalid" class="text-left">
                            <div *ngIf="confirmationform.get('zip')?.errors?.required">Zip is required.</div>
                          </ngb-alert>
                  </div>
                </div>

              </div>
              <div>
                <button class="btn btn-theme" type="submit">Pay Now</button></div>
              </div>
          </section>
